import { push, ref } from "firebase/database";
import { useState } from "react";
import { database } from "../firebase";

const CITIES = ['Agar Malwa','Alirajpur','Anuppur','Ashok Nagar','Balaghat','Barwani','Betul','Bhind','Bhopal','Burhanpur','Chhatarpur','Chhindwara','Damoh','Datia','Dewas','Dhar','Dindori','Guna','Gwalior','Harda','Hoshangabad','Indore','Jabalpur','Jhabua','Katni','Khandwa','Khargone','Mandla','Mandsaur','Morena','Narsinghpur','Neemuch','Panna','Raisen','Rajgarh','Ratlam','Rewa','Sagar','Satna','Sehore','Seoni','Shahdol','Shajapur','Sheopur','Shivpuri','Sidhi','Singrauli','Tikamgarh','Ujjain','Umaria','Vidisha'];

const EMPTY = { name:'', gender:'', email:'', mobile:'', qualification:'', state:'', city:'', pincode:'', parentName:'', idType:'', idNumber:'', course:'' };

const StudentRegistration = () => {
  const [form, setForm]       = useState(EMPTY);
  const [status, setStatus]   = useState(null); // null | 'success' | 'error'
  const [loading, setLoading] = useState(false);

  const set = (e) => setForm(p => ({ ...p, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await push(ref(database, "Enrolled_students"), { ...form, date: new Date().toISOString() });
      setStatus('success');
      setForm(EMPTY);
    } catch {
      setStatus('error');
    }
    setLoading(false);
  };

  return (
    <>
      <style>{`
        .reg-page {
          min-height: 100vh;
          background: linear-gradient(135deg, #f8fdf0 0%, #fffbe5 100%);
          padding: 48px 16px 64px;
        }
        .reg-card {
          background: #fff;
          border-radius: 18px;
          box-shadow: 0 8px 40px rgba(77,61,108,0.10);
          overflow: hidden;
          animation: regFadeUp 0.6s ease both;
        }
        @keyframes regFadeUp {
          from { opacity: 0; transform: translateY(32px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .reg-sidebar {
          background: linear-gradient(160deg, #4d3d6c 0%, #6b4f9e 100%);
          color: #fff;
          padding: 40px 32px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
        .reg-sidebar h2 { font-size: 1.6rem; font-weight: 700; line-height: 1.3; }
        .reg-sidebar .badge-pill {
          display: inline-block;
          background: rgba(255,255,255,0.15);
          border-radius: 50px;
          padding: 6px 14px;
          font-size: 13px;
          margin-bottom: 10px;
        }
        .reg-sidebar .contact-block { font-size: 13px; opacity: 0.85; line-height: 1.8; }
        .reg-sidebar .contact-block i { margin-right: 8px; }
        .reg-form-area { padding: 36px 32px; }
        .reg-section-label {
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 1px;
          text-transform: uppercase;
          color: #4d3d6c;
          margin-bottom: 12px;
          padding-bottom: 6px;
          border-bottom: 2px solid #ecf3d7;
        }
        .reg-form-area .form-control,
        .reg-form-area .form-select {
          border-radius: 8px;
          border: 1.5px solid #e0e0e0;
          font-size: 13.5px;
          padding: 9px 12px;
          transition: border-color 0.2s, box-shadow 0.2s;
        }
        .reg-form-area .form-control:focus,
        .reg-form-area .form-select:focus {
          border-color: #90b732;
          box-shadow: 0 0 0 3px rgba(144,183,50,0.15);
        }
        .reg-form-area label { font-size: 12.5px; font-weight: 600; color: #444; margin-bottom: 4px; }
        .btn-submit {
          background: linear-gradient(90deg, #90b732, #6fa020);
          color: #fff;
          border: none;
          border-radius: 10px;
          padding: 12px 0;
          font-size: 15px;
          font-weight: 600;
          width: 100%;
          transition: transform 0.2s, box-shadow 0.2s;
        }
        .btn-submit:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(144,183,50,0.35);
        }
        .btn-submit:disabled { opacity: 0.7; }
        .iso-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: rgba(255,255,255,0.12);
          border-radius: 10px;
          padding: 10px 16px;
          font-size: 13px;
          margin-top: 24px;
        }
        @media (max-width: 767px) {
          .reg-sidebar { padding: 28px 20px; }
          .reg-form-area { padding: 24px 16px; }
        }
      `}</style>

      <div className="reg-page">
        <div className="container" style={{ maxWidth: 960 }}>
          <div className="reg-card row g-0">

            {/* ── Sidebar ── */}
            <div className="col-md-4 reg-sidebar">
              <div>
                <img src={`${process.env.PUBLIC_URL}/tally.png`} alt="logo" style={{ height: 48, marginBottom: 24, filter: 'brightness(0) invert(1)' }} />
                <h2>Start Your Journey with Tally</h2>
                <p style={{ fontSize: 13, opacity: 0.8, marginTop: 12 }}>
                  Fill in the form and our team will get back to you within 24 hours.
                </p>
                <div className="mt-4 d-flex flex-column gap-2">
                  {['✅ Guaranteed Placement', '✅ Tally Certified Course', '✅ Expert Faculty', '✅ Internship Opportunities'].map(t => (
                    <span key={t} className="badge-pill">{t}</span>
                  ))}
                </div>
                <div className="iso-badge">
                  <span style={{ fontSize: 20 }}>🏅</span>
                  <span>ISO 9001:2015 Certified Institute</span>
                </div>
              </div>
              <div className="contact-block mt-4">
                <div><i className="bi bi-geo-alt-fill"></i>Purana Thana, Nearby SBI ATM,<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Damoh, MP – 470661</div>
                <div><i className="bi bi-telephone-fill"></i>9131385180</div>
                <div><i className="bi bi-envelope-fill"></i>shrikanttallyinstitute@gmail.com</div>
              </div>
            </div>

            {/* ── Form ── */}
            <div className="col-md-8 reg-form-area">
              <h5 className="fw-bold mb-1" style={{ color: '#4d3d6c' }}>Student Enrollment Form</h5>
              <p className="text-muted mb-4" style={{ fontSize: 13 }}>All fields marked <span className="text-danger">*</span> are required.</p>

              {status === 'success' && (
                <div className="alert alert-success d-flex align-items-center gap-2 py-2" style={{ fontSize: 13 }}>
                  <i className="bi bi-check-circle-fill"></i> Registration successful! We'll contact you soon.
                </div>
              )}
              {status === 'error' && (
                <div className="alert alert-danger d-flex align-items-center gap-2 py-2" style={{ fontSize: 13 }}>
                  <i className="bi bi-exclamation-circle-fill"></i> Something went wrong. Please try again.
                </div>
              )}

              <form onSubmit={handleSubmit}>

                {/* Personal Info */}
                <div className="reg-section-label">Personal Information</div>
                <div className="row g-3 mb-3">
                  <div className="col-sm-6">
                    <label>Full Name <span className="text-danger">*</span></label>
                    <input name="name" value={form.name} onChange={set} className="form-control" placeholder="Enter full name" required />
                  </div>
                  <div className="col-sm-6">
                    <label>Gender <span className="text-danger">*</span></label>
                    <select name="gender" value={form.gender} onChange={set} className="form-select" required>
                      <option value="">Select gender</option>
                      <option>Male</option>
                      <option>Female</option>
                    </select>
                  </div>
                  <div className="col-sm-6">
                    <label>Mobile <span className="text-danger">*</span></label>
                    <input name="mobile" value={form.mobile} onChange={set} className="form-control" placeholder="10-digit mobile" maxLength={10} required />
                  </div>
                  <div className="col-sm-6">
                    <label>Email <span className="text-danger">*</span></label>
                    <input name="email" type="email" value={form.email} onChange={set} className="form-control" placeholder="your@email.com" required />
                  </div>
                  <div className="col-sm-6">
                    <label>Qualification</label>
                    <select name="qualification" value={form.qualification} onChange={set} className="form-select">
                      <option value="">Select qualification</option>
                      {['Any Graduate','X Standard','ITI/Diploma','XII Standard','B.Com','B.E/B.Tech','BBA/BBM','M.Com','MBA','Professional qualification','Other'].map(q => <option key={q}>{q}</option>)}
                    </select>
                  </div>
                  <div className="col-sm-6">
                    <label>Parent's Name</label>
                    <input name="parentName" value={form.parentName} onChange={set} className="form-control" placeholder="Parent / Guardian name" />
                  </div>
                </div>

                {/* Address */}
                <div className="reg-section-label">Address</div>
                <div className="row g-3 mb-3">
                  <div className="col-sm-4">
                    <label>State <span className="text-danger">*</span></label>
                    <select name="state" value={form.state} onChange={set} className="form-select" required>
                      <option value="">Select state</option>
                      <option>Madhya Pradesh</option>
                    </select>
                  </div>
                  <div className="col-sm-4">
                    <label>City <span className="text-danger">*</span></label>
                    <select name="city" value={form.city} onChange={set} className="form-select" required>
                      <option value="">Select city</option>
                      {CITIES.map(c => <option key={c}>{c}</option>)}
                    </select>
                  </div>
                  <div className="col-sm-4">
                    <label>Pincode <span className="text-danger">*</span></label>
                    <input name="pincode" value={form.pincode} onChange={set} className="form-control" placeholder="6-digit pincode" maxLength={6} required />
                  </div>
                </div>

                {/* ID & Course */}
                <div className="reg-section-label">ID Proof & Course</div>
                <div className="row g-3 mb-4">
                  <div className="col-sm-4">
                    <label>ID Proof Type</label>
                    <select name="idType" value={form.idType} onChange={set} className="form-select">
                      <option value="">Select type</option>
                      <option>Aadhar</option><option>PAN</option><option>Voter ID</option>
                    </select>
                  </div>
                  <div className="col-sm-4">
                    <label>ID Proof Number</label>
                    <input name="idNumber" value={form.idNumber} onChange={set} className="form-control" placeholder="ID number" />
                  </div>
                  <div className="col-sm-4">
                    <label>Course Interested In</label>
                    <select name="course" value={form.course} onChange={set} className="form-select">
                      <option value="">Select course</option>
                      <option>Tally Professional</option>
                      <option>Tally Expert</option>
                      <option>GST Course</option>
                    </select>
                  </div>
                </div>

                <button type="submit" className="btn-submit" disabled={loading}>
                  {loading ? <><span className="spinner-border spinner-border-sm me-2"></span>Submitting...</> : 'Submit Enrollment'}
                </button>
              </form>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default StudentRegistration;
